import React from "react";
import "./ServicesPage.css";
import { Link } from "react-router-dom";

const services = [
  {
    title: "הובלות מבנים",
    desc: "הובלת דירות בצורה מקצועית, בטוחה ומסודרת, עם צוות מנוסה ושירות אישי.",
    img: "/7.jpeg",
    path: "/Building_Transportation",
  },
  {
    title: "   הובלות עם מנוף הרמה",
    desc: "שירותי הובלה עם מנוף להרמת והעברת ציוד וריהוט במקומות שקשה להגיע אליהם.",
    img: "/6.jpeg",
    path: "/Moving_with_a_lifting_crane",
  },
  {
    title: "שירותי מנוף",
    desc: "מנופים להרמת ציוד, ריהוט, משטחים ופריטים כבדים בצורה בטוחה ויעילה.",
    img: "/5.jpeg",
    path: "/Crane_Rental",
  },
  {
    title: "  מנוף סל להרמת אדם",
    desc: "הובלת ציוד, ריהוט ומשרדים לעסקים תוך תכנון נכון ושמירה על הציוד.",
    img: "/10.jpeg",
    path: "/Renting_a_basket_crane_for_lifting_a_person",
  },
  {
    title: "שינוע ציוד כבד",
    desc: "שינוע והרמת ציוד כבד באמצעות פתרונות מקצועיים והתאמה מלאה לתנאי השטח.",
    img: "/9.jpeg",
    path: "/Transporting_heavy_equipment",
  },
  {
    title: " הרמת זכוכית וציוד כבד",
    desc: "פתרונות הרמה ושינוע מיוחדים עבור ציוד, ריהוט ופריטים גדולים ומורכבים.",
    img: "/8.jpeg",
    path: "/Transportation_and_lifting_of_glass_in_a_vacuum",
  },
];

export default function ServicesPage() {
  return (
    <section className="services-page">

      <div className="services-header">

        <span className="services-label">
          נצר הובלות ומנופים בע״מ
        </span>

        <h1 className="page-title">
          השירותים שלנו
        </h1>

        <p className="services-intro">
          פתרונות הובלה, מנופים, הרמות ושינוע ברמה מקצועית,
          עם דגש על בטיחות, אמינות ושירות ללא פשרות.
        </p>

      </div>


      <div className="services-grid">

        {services.map((item, index) => (
          <Link
            to={item.path}
            key={index}
            className="service-card"
          >

            <div className="service-image-wrapper">

              <img
                src={item.img}
                alt={item.title}
                className="service-image"
                loading="lazy"
              />

              <div className="service-overlay"></div>

        

            </div>


            <div className="service-content">

              <h3>
                {item.title}
              </h3>

              <p>
                {item.desc}
              </p>

              <span className="service-link">
                לפרטים נוספים
                <span className="service-arrow">
                  ←
                </span>
              </span>

            </div>

          </Link>
        ))}

      </div>

    </section>
  );
}